import React from "react";
import howLongAgo from "../../util/timeDescription";
import {subduedTextColour, timelineColour} from "../../style/styleConsts";
import styled from "styled-components";


export default function ActivityRow(props) {
    return <Row className="t-activity-row" onClick={props.onClick}>
        {props.omitLine ?
            null :
            <VerticalLine/>
        }
        <AgeCell className="t-age">
            {howLongAgo(props.dateTime)}
        </AgeCell>
        <ActionCell className="t-action">
            {props.action}
        </ActionCell>
        {props.children ?
            <ContentCell>{props.children}</ContentCell>
          : null
        }
    </Row>;
}

const Row = styled.div`
    position: relative;
    z-index: 0;
    margin-top: 6px;
    margin-bottom: 10px;
    cursor: ${props => props.onClick ? "pointer" : "default"};
    display: flex;
    align-items: flex-start;
    flex-shrink: 0;
`;

const Cell = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
`;

const AgeCell = styled(Cell)`
    color: ${subduedTextColour};
    white-space: nowrap;
    flex-basis: 50px;
`;

const ActionCell = styled(Cell)`
    background-color: ${timelineColour};
    color: ${subduedTextColour};
    padding: 1px 4px;
    margin-right: 10px;
    border-radius: 5px;
    text-align: center;
    z-index: 0;
    white-space: nowrap;
    flex-basis: 50px;
`;

const ContentCell = styled(Cell)`
    flex-grow: 1;
    flex-shrink: 1;
`;

const VerticalLine = styled.div`
    position: absolute;
    top: 4px;
    bottom: -13px;
    left: 75px;
    width: 0;
    border-right: 3px solid ${timelineColour};
    z-index: -1;
`;